// extracted by mini-css-extract-plugin
export var aircallIframe = "_lf-3";
export var fabContainer = "_lf-5";
export var fabRinging = "_lf-6";
export var loadingOverlay = "_lf-4";
export var pulse = "_lf-7";
export var widgetContent = "_lf-2";
export var widgetPanel = "_lf-0";
export var widgetPanelExpanded = "_lf-1";